import TrackProAPI from './track-pro-api'

export const login = (groupId: string) => {
    return TrackProAPI.post('/login', { groupId })
}
